/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Month/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import ScrollIntoViewIf from 'DesignSystem/ScrollIntoViewIf/react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Month({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthAndYearSelector/Dropdown/Content/Month",
  closePopover
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dropdownMonthSelectedValueData = fromData.useDataValue({ viewPath,
context: 'dropdown_month',
path: 'selected',
})
let dropdownMonthSelectedValueData1 = fromData.useDataValue({ viewPath,
context: 'dropdown_month',
path: 'selected',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  closePopover,
  isHovered
  
})
let dropdownMonthTextValueData = fromData.useDataValue({ viewPath,
context: 'dropdown_month',
path: 'text',
})
let dropdownMonthSelectedValueData2 = fromData.useDataValue({ viewPath,
context: 'dropdown_month',
path: 'selected',
})
  return (<React.Fragment
>
<ScrollIntoViewIf
  viewPath={`${viewPath}/ScrollIntoViewIf`}
 condition={dropdownMonthSelectedValueData ? true : false}
 data="dropdown_month.selected"
/>
<button
  data-testid="Month.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pl-1-5nkPt': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-5nkPt': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-5nkPt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-4-5nkPt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-5nkPt': isHovered ? dtColorsNeutral100 : dropdownMonthSelectedValueData1 ? dtColorsNeutral100 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight={dropdownMonthSelectedValueData2 ? "semibold" : "regular"}
 closePopover={closePopover}
 data="dropdown_month.text"
 text={dropdownMonthTextValueData}
 data="dropdown_month.selected"
/>
</button>
{children}
</React.Fragment>)
}